"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const libConfig_1 = __importDefault(require("./libConfig"));
const round_1 = __importDefault(require("./round"));
function getRoundNumber(value, rounding = libConfig_1.default.rounding) {
    return (0, round_1.default)(value, rounding.type, rounding.digits);
}
exports.default = getRoundNumber;
//# sourceMappingURL=getRoundNumber.js.map